export class ApplicationInsightModel {
  UserName: string;
  UserFullName: string;
  AuthType: any;
  AuthDomain: string;
  DataOwnerId: string;
  ImpersonateState: string;
}
